import SwitchWidget from '~/containers/Admin/ControlPanel/SwitchWidget';

// Dumb switch driven by component-owned state passed through ui:options
const StateSwitchWidget = (props) => {
    const { options = {} } = props;
    const { checked, onToggle, disabled } = options;
    return <SwitchWidget value={!!checked} onChange={onToggle} disabled={disabled} />;
};

export default StateSwitchWidget;
